import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Challenge from "@/pages/Challenge";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/challenge" element={<Challenge />} />
          <Route path="/" element={<Navigate to="/challenge" replace />} />
          <Route path="*" element={<Navigate to="/challenge" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
